import { render, staticRenderFns } from "./OrderQuery.vue?vue&type=template&id=37123b86&scoped=true&"
import script from "./OrderQuery.vue?vue&type=script&lang=js&"
export * from "./OrderQuery.vue?vue&type=script&lang=js&"
import style0 from "./OrderQuery.vue?vue&type=style&index=0&id=37123b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37123b86",
  null
  
)

export default component.exports